import { actionCreator } from '@ardoq/rxbeach';
import { Trackable } from 'tracking/trackPayload';
import { MenuItemGroupCategory } from '@ardoq/sidebar-menu';

export const closeSidebar = actionCreator<Trackable<object>>(
  '[navigationTopBar] CLOSE_SIDEBAR'
);

export const openSidebar = actionCreator<Trackable<object>>(
  '[navigationTopBar] OPEN_SIDEBAR'
);

export const hoverSidebar = actionCreator<Trackable<object>>(
  '[navigationTopBar] HOVER_SIDEBAR'
);

export const openNotificationsMenu = actionCreator<Trackable<object>>(
  '[navigationTopBar] OPEN_NOTIFICATIONS_MENU'
);

export const closeNotificationsMenu = actionCreator(
  '[navigationTopBar] CLOSE_NOTIFICATIONS_MENU'
);

export const toggleOrganizationSettingsDropdown = actionCreator<Trackable>(
  '[navigationTopBar] TOGGLE_ORGANIZATION_SETTINGS_DROPDOWN'
);

export const closeOrganizationSettingsDropdown = actionCreator<Trackable>(
  '[navigationTopBar] CLOSE_ORGANIZATION_SETTINGS_DROPDOWN'
);

export const setOrganizationSettingsSubMenuIndex = actionCreator<number | null>(
  '[navigationTopBar] SET_ORGANIZATION_SETTINGS_SUBMENU_INDEX'
);

export const toggleMenuCategory = actionCreator<
  Trackable<{
    category: MenuItemGroupCategory;
  }>
>('[navigationTopBar] TOGGLE_MENU_CATEGORY');
